import React from 'react';
import { SunHorizon, Sun, MoonStars, Check } from '@phosphor-icons/react';

const META = {
  morning: { icon: SunHorizon, label: 'Morning whisper' },
  afternoon: { icon: Sun, label: 'Afternoon mission' },
  night: { icon: MoonStars, label: "Tonight's diary line" },
};

export const RhythmCard = ({ rhythm, onDone }) => {
  if (!rhythm) return null;
  const { icon: Icon, label } = META[rhythm.slot];
  return (
    <div className="home-card" data-testid="rhythm-card">
      <p className="text-xs uppercase tracking-[0.25em] text-bx-gold font-bold flex items-center gap-2">
        <Icon size={16} weight="fill" /> {label}
      </p>
      <p className="mt-3 text-base leading-relaxed text-white/90 italic" data-testid="rhythm-text">“{rhythm.text}”</p>
      {rhythm.slot === 'afternoon' && (
        rhythm.done
          ? <p className="mt-4 text-sm text-bx-volt inline-flex items-center gap-1" data-testid="rhythm-done"><Check weight="bold" /> done — it's so proud of you</p>
          : <button onClick={onDone} data-testid="rhythm-done-btn" className="mt-4 px-5 py-2 rounded-full border border-white/25 text-sm font-bold text-white hover:bg-white/10 transition-colors">I did it</button>
      )}
    </div>
  );
};

export default RhythmCard;
